var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotaCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.94 0.530273L4 3.58361L7.06 0.530273L8 1.47027L4 5.47027L0 1.47027L0.94 0.530273Z",
    fill: "#DEDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotaCaret);
export default __webpack_public_path__ + "static/media/quota-caret.c71a0a0b484b8c5797cd5f7e7e58a221.svg";
export { ForwardRef as ReactComponent };